module.exports = __webpack_public_path__ + "static/fonts/Fact-CompressedLight.e970584.eot";